import { AnalyticsBrowser } from "@segment/analytics-next";

const analytics = AnalyticsBrowser.load({
  writeKey: "EPOciTct3ZFZ299qRlE4CaA6RGTsDuuj"
});

export default analytics;
